import { DEVICE } from 'constant';
import styled from 'styled-components';

export const SignUpContainer = styled.div`
  display: flex;
  width: 750px;
  height: 480px;
  background-color: ${(props) => props.bgColor};
  border-radius: 24px;
  margin-block-start: 40px;
`;

export const SignUpBackground = styled.div`
  display: flex;
  background: url(${(props) => props.bgImg});
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

export const InputContainer = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  flex-direction: column;
`;

export const InputWrapper = styled.div`
  display: flex;
  border-bottom: 1px solid ${(props) => props.borderColor};
  width: 100%;
`;

export const InputsContainer = styled.div`
  display: flex;
  flex-direction: column;
  & > :not(:last-child) {
    margin-bottom: 40px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 32px;
  width: 100%;

  @media ${DEVICE.small} {
    margin-top: 40px;
  }
`;

export const CredentialPageContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HaveAccountContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${(props) => props.marginTop};

  & > :first-child {
    margin-inline-end: 4px;
  }
`;

export const ErrorContainer = styled.div`
  display: flex;
  position: absolute;
  margin-top: 2px;
  top: ${(props) => (props.top ? props.top : '38px')};
  width: 100%;
  ${(props) => props.isRtl && 'direction: rtl;'}/* @media ${DEVICE.small} {
    top: ${(props) => (props.top ? props.top : '32px')};
  } */
`;

export const MobileCredentialPageContainer = styled.div`
  display: flex;
  align-items: center;
  height: -webkit-fill-available;
  width: 100%;
  height: 100vh;
  padding: 30px 39px 0;
  flex-direction: column;
  background: ${(props) => props.bgColor};
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -ms-box-sizing: border-box;

  @media ${DEVICE.xxs} {
    padding: 50px 25px 0;
  }
`;
